// get_push_notifications
export const GET_PUSH_NOTIFICATIONS = 'get_push_notifications';
export const GET_PUSH_NOTIFICATIONS_SUCCESSFUL =
  'get_push_notifications_successfull';
export const GET_PUSH_NOTIFICATIONS_FAILED = 'get_push_notifications_failed';
